export const officeGroups = [
  {
    country: 'India',
    offices: [
      { label: 'Corporate Office · Pune', address: '15A, 4th Floor, City Vista, Fountain Road, Kharadi, Pune, Maharashtra 411014', lat: 18.5614, lng: 73.9447 },
      { label: 'Pune · EON Free Zone', address: 'Cluster D, Wing 4, EON Free Zone, Kharadi, Pune, MH 411016', lat: 18.5525, lng: 73.9500 },
      { label: 'Hyderabad · Madhapur', address: '13th Floor, Survey No. 64, Building No. 9, Madhapur, Hyderabad, Telangana 500081', lat: 17.4483, lng: 78.3915 },
      { label: 'Hyderabad · HITEC City', address: 'Phoenix H10, Tower 2, 6th Floor, Phoenix SEZ Access Road, Phase 2, HITEC City, Hyderabad, TS 500081', lat: 17.4435, lng: 78.3772 },
      { label: 'Bangalore · Hebbal', address: '8, Bellary Rd, Ganganagar, Bangalore, KA 560032', lat: 13.0225, lng: 77.5891 },
      { label: 'Bangalore · Domlur', address: 'Cherry Hills, Embassy Golf Links Business Park, Challaghatta, Bangalore, KA 560071', lat: 12.9552, lng: 77.6484 },
      { label: 'Gurgaon · Cybercity', address: 'Cybercity, Phase III, Gurugram, HR 122002', lat: 28.4950, lng: 77.0895 },
    ],
  },
  {
    country: 'USA',
    offices: [{ label: 'New York', address: '1345 Avenue of the Americas, New York, NY 10105, USA', lat: 40.7626, lng: -73.9794 }],
  },
  {
    country: 'UK',
    offices: [{ label: 'Waltham Cross', address: '114 Lodge Crescent, Waltham Cross, England, EN8 8BJ', lat: 51.6858, lng: -0.0338 }],
  },
  {
    country: 'UAE',
    offices: [{ label: 'Dubai', address: 'Level 3 & 14, Boulevard Plaza Tower One, Sheikh Mohammed bin Rashid Blvd, Dubai, UAE', lat: 25.1957, lng: 55.2721 }],
  },
  {
    country: 'Malaysia',
    offices: [{ label: 'Kuala Lumpur', address: 'Etiqa Twins, Level 25, Tower 2, 11 Jalan Pinang, 50450 Kuala Lumpur', lat: 3.1541, lng: 101.7113 }],
  },
  {
    country: 'Netherlands',
    offices: [{ label: 'Diemen (Amsterdam)', address: 'Diemerhof 42, 1112 XN Diemen, Netherlands', lat: 52.3419, lng: 4.9634 }],
  },
  {
    country: 'Hong Kong',
    offices: [{ label: 'Taikoo Shing', address: "27/F, 1111 King's Road, Taikoo Shing, Hong Kong", lat: 22.2864, lng: 114.2159 }],
  },
];

export const allOffices = officeGroups.flatMap((g) =>
  g.offices.map((o) => ({ ...o, country: g.country }))
);

const toRad = (d) => (d * Math.PI) / 180;

export const distanceKm = (lat1, lng1, lat2, lng2) => {
  const R = 6371;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export const nearestOffice = (lat, lng) =>
  allOffices.reduce(
    (best, o) => {
      const d = distanceKm(lat, lng, o.lat, o.lng);
      return d < best.km ? { office: o, km: d } : best;
    },
    { office: null, km: Infinity }
  );
